import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import { ShieldAlert } from "lucide-react";
import React from "react";

import IntegritySignalCardComponent, {
  type IntegritySignalCardData,
} from "../IntegritySignalCard/IntegritySignalCard";

export type SignalsTabProps = {
  integritySignals: IntegritySignalCardData[];
  interviewStartTime?: string | null;
  interviewDuration?: number | null;
  onSeek?(t: number): void;
};

const SignalsTab: React.FC<SignalsTabProps> = ({
  integritySignals,
  interviewStartTime,
  interviewDuration,
  onSeek,
}) => {
  const detectedSignals = integritySignals.filter((s) => s.detected);
  const notDetectedSignals = integritySignals.filter((s) => !s.detected);

  if (integritySignals.length === 0) {
    return (
      <Flex flexDirection="column" align="center" py="10">
        <Box fontWeight="600" color="gray.600" fontSize="md" textAlign="center">
          No integrity signals
        </Box>
        <Box
          fontSize="sm"
          fontWeight={400}
          color="gray.600"
          mt="2"
          px="6"
          textAlign="center"
        >
          Integrity signal analysis has not been run for this interview.
        </Box>
      </Flex>
    );
  }

  return (
    <Box px="4" py="4">
      {detectedSignals.length > 0 && (
        <Box mb="4">
          <Flex align="center" gap="1.5" mb="3">
            <Icon as={ShieldAlert} boxSize="3.5" color="gray.600" />
            <Text
              fontWeight="600"
              fontSize="xs"
              color="gray.600"
              textTransform="uppercase"
            >
              {detectedSignals.length} integrity signal
              {detectedSignals.length !== 1 ? "s" : ""} detected
            </Text>
          </Flex>
          <Flex direction="column" gap="2">
            {detectedSignals.map((signal) => (
              <IntegritySignalCardComponent
                key={signal.id}
                signal={signal}
                interviewStartTime={interviewStartTime}
                interviewDuration={interviewDuration}
                onSeek={onSeek}
              />
            ))}
          </Flex>
        </Box>
      )}
      {notDetectedSignals.length > 0 && (
        <Box>
          <Text
            fontWeight="600"
            fontSize="xs"
            color="gray.600"
            mb="3"
            textTransform="uppercase"
          >
            No integrity signals detected
          </Text>
          <Flex direction="column" gap="2">
            {notDetectedSignals.map((signal) => (
              <IntegritySignalCardComponent
                key={signal.id}
                signal={signal}
                interviewStartTime={interviewStartTime}
                interviewDuration={interviewDuration}
                onSeek={onSeek}
              />
            ))}
          </Flex>
        </Box>
      )}
    </Box>
  );
};

export default SignalsTab;
